import script from "./FeaturedCourses.vue?vue&type=script&setup=true&lang=js"
export * from "./FeaturedCourses.vue?vue&type=script&setup=true&lang=js"

import "./FeaturedCourses.vue?vue&type=style&index=0&id=2e503602&lang=css"

const __exports__ = script;

export default __exports__